import { render } from "./edit.vue?vue&type=template&id=24d161d4"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/branch/department/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24d161d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24d161d4', __exports__)) {
    console.log('reload')
    api.reload('24d161d4', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=24d161d4", () => {
    console.log('re-render')
    api.rerender('24d161d4', render)
  })

}


export default __exports__